<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="loading"
  >

    <b-card>
      <b-table
        striped
        :items="list"
        :fields="tableColumns"
        show-empty
        empty-text="Empty"
      >
        <template #cell(actions)="data">
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-primary"
            :to="`/businesses/${data.item.id}/pending-approvals`"
          >
            <feather-icon
              size="20"
              icon="EyeIcon"
            />
          </b-button>
        </template>
      </b-table>
      <!-- <base-pagination
        v-model="queryParams.page"
        class="mt-1"
        :total="total"
        @input="fetchList"
        @new-per-page="queryParams.perPage = $event"
      /> -->
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'
import { formatDate } from '@/@core/utils/filter'

export default {
  components: {
    BCard, BTable, BOverlay, BButton,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)

    const tableColumns = [
      {
        label: 'Name',
        key: 'name',
        formatter: val => val.en,
      },
      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      {
        label: 'Phone No',
        key: 'phoneNumber',
      },
      {
        label: 'Email',
        key: 'email',
      },
      'actions',
    ]
    const loading = ref(false)
    const list = ref([])
    // const total = ref(0)

    // const queryParams = reactive({
    //   perPage: 10,
    //   page: 1,
    // })

    const fetch = async () => {
      loading.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessPendingApprovals')
      const { data } = res.data
      list.value = data
      loading.value = false
    }

    fetch()

    //     watch([toRef(queryParams, 'perPage')], () => {
    //     fetch()
    //   })
    return {
      list,
      // total,
      loading,
      tableColumns,
    }
  },
}
</script>
